import { TableDrawer } from "@components/TableDrawer/TableDrawer";
import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { decodeHTML } from "@utils/CommonUtils";
import { drilldownData, ModuleConfig } from "@utils/drilldownData";
import { Button, Pagination, TableColumnsType, Typography } from "antd";
import { get as _get } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, DataTable } from "~/Components";
import ConfirmationModal from "~/Components/Modal/confirmation-modal";
import { useNotification } from "~/Hooks/useNotification";
import ActionDropdown, { TypeData } from "~/Modules/ECMS/PASSENGER/ActionDropdown";
import { magpCMSApi, post } from "~/Services";
import { magpHost } from "~/Utils";
import {
  renderActionsColumn,
  renderDateColumn,
  renderImageColumn,
  renderPublishedColumn,
} from "~/Utils/TableRenderFunction";
import { useGalleryList } from "../Gallery.hook";

export const GalleryList = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState<string | undefined>(selectedRowData?.id);

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteConfirmLoading, setDeleteConfirmLoading] = useState(false);

  const [searchValue, setSearchValue] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [data, setData] = useState<any>([]);
  const [sortedData, setSortedData] = useState<any>([]);
  const currentPageData = sortedData.slice(currentPage * 10, (currentPage + 1) * 10);
  const [sortOrder, setSortOrder] = useState<string | undefined>();
  const [orderByName, setOrderByName] = useState<string>("id");
  const [selectedPublishedType, setselectedPublishedType] = useState<any>("");
  console.log("selectedPublishedType", selectedPublishedType);
  const publishedType: TypeData[] = [
    {
      label: "Published",
      value: true,
    },
    {
      label: "Unpublished",
      value: false,
    },
  ];

  const [reviewNotes, setReviewNotes] = useState("");
  const [reviewNotesError, setReviewNotesError] = useState(false);

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useGalleryList(id || "");

  useEffect(() => {
    if (id) {
      refetchDocument();
    }
  }, [id]);

  useEffect(() => {
    let filteredData = data;

    if (searchValue) {
      filteredData = filteredData.filter((item: any) => {
        return item.title.toString().includes(searchValue.toLowerCase());
      });
    }
    if (selectedPublishedType !== undefined && selectedPublishedType !== "") {
      filteredData = filteredData.filter((item: any) => item.field_gallery_published === selectedPublishedType);
    }
    setSortedData(filteredData);
    setTotalRecords(filteredData.length);
    setCurrentPage(0);
  }, [data, searchValue, selectedPublishedType]);

  const getRecords = () => {
    setIsLoading(true);
    let url = `/api/get-gallery-page/all-fields`;
    magpCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setTotalRecords(envelopes.length);
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        setIsLoading(false);
      });
  };

  const columns: TableColumnsType = [
    {
      title: "Image",
      dataIndex: "field_src_url",
      key: "field_src_url",
      width: 50,
      render: renderImageColumn,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 100,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "title"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "title"
            ? "descend"
            : undefined,
      render: (text) => decodeHTML(text),
    },
    {
      title: "Published",
      dataIndex: "field_gallery_published",
      key: "field_gallery_published",
      width: 50,
      render: renderPublishedColumn,
    },
    {
      title: "Created At",
      dataIndex: "field_gallery_created_at",
      key: "field_gallery_created_at",
      width: 100,
      fixed: "right",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_gallery_created_at"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_gallery_created_at"
            ? "descend"
            : undefined,
    },
    {
      title: "Updated At",
      dataIndex: "field_gallery_updated_at",
      key: "field_gallery_updated_at",
      width: 100,
      fixed: "right",
      render: (value: any) => renderDateColumn(value),
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "field_gallery_updated_at"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "field_gallery_updated_at"
            ? "descend"
            : undefined,
    },
    {
      title: "Actions",
      key: "actions",
      width: 50,
      fixed: "right",
      render: (record: any) =>
        renderActionsColumn(
          record,
          setSelectedRowData,
          setDrawerVisible,
          (e: any) => {
            e.preventDefault();
            navigate(`/dedicated/magp/gallery/add?editId=${record.id}`);
          },
          undefined,
          setDeleteModalVisible,
          "faq"
        ),
    },
  ];

  useEffect(() => {
    getRecords();
  }, []);

  useEffect(() => {
    setId(selectedRowData?.id);
  }, [selectedRowData]);

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";

    if (sortOrder === "asc") {
      setSortOrder("desc");
      order = "desc";
    } else if (sortOrder === "desc") {
      setSortOrder(undefined);
      order = undefined;
    } else if (sortOrder === undefined) {
      setSortOrder("asc");
      order = "asc";
    }

    setOrderByName(column.dataIndex);

    const tempData = [...data];
    setSortedData(tempData.sort((a: any, b: any) => handleSort(a, b, order, column.dataIndex)));
    setCurrentPage(0);
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }

    const payload = {
      action: action,
      method: method,
      module: "Gallery",
      subModule: "gallery",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: data,
      status: status,
    };

    post("/management/publish", payload)
      .then((response) => {
        openToast({
          content: "Data Sent for Review",
          type: "success",
        });
      })
      .catch((err: any) => {
        openToast({
          content: "Failed to send data",
          type: "error",
        });
      });
  };

  async function sendDeleteFAQRequest(reviewNotes: string) {
    try {
      await onSubmit(
        selectedRowData,
        `${magpHost}/api/gallery-page-api/${selectedRowData?.id}`,
        "DELETE",
        "DELETE",
        "PENDING",
        reviewNotes
      );
    } catch (err) {}
  }

  return (
    <ContentWrapper
      title={"Gallery"}
      actionItems={
        <Button
          onClick={() => {
            navigate("/dedicated/magp/gallery/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Gallery
        </Button>
      }
    >
      <DataTable
        columns={columns.map((col) => ({
          ...col,
          onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
        }))}
        multiSelect={false}
        className="table-clickable"
        tableData={
          currentPageData
            ? currentPageData?.map((d: any) => {
                return {
                  ...d,
                };
              })
            : []
        }
        isLoading={isLoading}
        exportFileName="CONTRACT"
        isPagination={true}
        recordsPerPage={10}
        onSearchChange={(searchText: string) => {
          setSearchValue(searchText);
          setCurrentPage(0);
        }}
        hideExport={true}
        isServerSearchApi={false}
        searchPlaceholderText={"Search"}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
        additionalCTA={
          <div className="flex items-center space-x-2">
            <ActionDropdown
              value={selectedPublishedType}
              options={publishedType}
              onChange={setselectedPublishedType}
              placeholder="Select Published"
            />
          </div>
        }
      />
      <div className="pagination">
        <Pagination
          defaultCurrent={1}
          current={currentPage + 1}
          total={totalRecords}
          onChange={(curPage) => {
            setCurrentPage(curPage - 1);
          }}
          showSizeChanger={false}
        />
      </div>

      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "gallery") as ModuleConfig]}
        data={drilldown?.[0]}
      />

      <ConfirmationModal
        type="delete"
        open={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onSubmit={sendDeleteFAQRequest}
      />
    </ContentWrapper>
  );
};

function handleSort(a: any, b: any, order: string, sortBy: string) {
  if (sortBy === "title") {
    const numberA = extractNumber(a[sortBy]);
    const numberB = extractNumber(b[sortBy]);

    if (order === "desc") {
      return numberA < numberB ? 1 : -1;
    } else if (order === "asc") {
      return numberA > numberB ? 1 : -1;
    } else {
      return 0;
    }
  }

  if (order === "desc") {
    return a[sortBy] < b[sortBy] ? 1 : -1;
  } else if (order === "asc") {
    return a[sortBy] > b[sortBy] ? 1 : -1;
  } else {
    return 0;
  }
}

function extractNumber(question: string): number {
  const match = question.match(/Q(\d+)/);
  return match ? parseInt(match[1], 10) : 0;
}
